const zwds = {
  zwds: {
    // Palace names
    palaces: {
      命宮: "命宮",
      兄弟: "兄弟宮",
      夫妻: "夫妻宮",
      子女: "子女宮",
      財帛: "財帛宮",
      疾厄: "疾厄宮",
      遷移: "遷移宮",
      交友: "交友宮",
      官祿: "官祿宮",
      田宅: "田宅宮",
      福德: "福德宮",
      父母: "父母宮",
    },

    // Heavenly Stems
    stems: {
      甲: "甲",
      乙: "乙",
      丙: "丙",
      丁: "丁",
      戊: "戊",
      己: "己",
      庚: "庚",
      辛: "辛",
      壬: "壬",
      癸: "癸",
    },

    // Earthly Branches
    branches: {
      子: "子（鼠）",
      丑: "丑（牛）",
      寅: "寅（虎）",
      卯: "卯（兔）",
      辰: "辰（龍）",
      巳: "巳（蛇）",
      午: "午（馬）",
      未: "未（羊）",
      申: "申（猴）",
      酉: "酉（雞）",
      戌: "戌（狗）",
      亥: "亥（豬）",
    },

    // Month Heavenly Stems
    monthBranches: {
      子: "1",
      丑: "2",
      寅: "3",
      卯: "4",
      辰: "5",
      巳: "6",
      午: "7",
      未: "8",
      申: "9",
      酉: "10",
      戌: "11",
      亥: "12",
    },

    // Day Heavenly Stems
    dayBranches: {
      子: "子",
      丑: "丑",
      寅: "寅",
      卯: "卯",
      辰: "辰",
      巳: "巳",
      午: "午",
      未: "未",
      申: "申",
      酉: "酉",
      戌: "戌",
      亥: "亥",
    },

    // Main stars
    mainStars: {
      紫微: "紫微星",
      天機: "天機星",
      太陽: "太陽星",
      武曲: "武曲星",
      天同: "天同星",
      廉貞: "廉貞星",
      天府: "天府星",
      太陰: "太陰星",
      貪狼: "貪狼星",
      巨門: "巨門星",
      天相: "天相星",
      天梁: "天梁星",
      七殺: "七殺星",
      破軍: "破軍星",
    },

    // Transformations
    transformations: {
      化科: "化科",
      化權: "化權",
      化祿: "化祿",
      化忌: "化忌",
    },

    // Minor stars
    minorStars: {
      文昌: "文昌星",
      文曲: "文曲星",
      左輔: "左輔星",
      右弼: "右弼星",
      天魁: "天魁星",
      天鉞: "天鉞星",
      天廚: "天廚星",
      天刑: "天刑星",
      天姚: "天姚星",
      天喜: "天喜星",
      地空: "地空星",
      地劫: "地劫星",
      火星: "火星",
      鈴星: "鈴星",
    },

    // Five Elements
    fiveElements: {
      水二局: "水二局",
      木三局: "木三局",
      金四局: "金四局",
      土五局: "土五局",
      火六局: "火六局",
    },

    // Chart sections
    chart: {
      年: "年",
      月: "月",
      日: "日",
      時: "時",
      生肖: "生肖",
      五行: "五行",
      陽曆: "陽曆",
      陰曆: "陰曆",
      男: "男",
      女: "女",
      命主: "命主",
      身主: "身主",
      大限: "大限",
      小限: "小限",
      流年: "流年",
      age: "年齡",
      westernZodiac: "西方星座",
      陰: "陰",
      陽: "陽",
      歲: "歲",
    },

    lunarDays: {
      初一: "1",
      初二: "2",
      初三: "3",
      初四: "4",
      初五: "5",
      初六: "6",
      初七: "7",
      初八: "8",
      初九: "9",
      初十: "10",
      十一: "11",
      十二: "12",
      十三: "13",
      十四: "14",
      十五: "15",
      十六: "16",
      十七: "17",
      十八: "18",
      十九: "19",
      二十: "20",
      廿一: "21",
      廿二: "22",
      廿三: "23",
      廿四: "24",
      廿五: "25",
      廿六: "26",
      廿七: "27",
      廿八: "28",
      廿九: "29",
      三十: "30",
      三十一: "31",
    },

    zodiac: {
      鼠: "鼠",
      牛: "牛",
      虎: "虎",
      兔: "兔",
      龍: "龍",
      蛇: "蛇",
      馬: "馬",
      羊: "羊",
      猴: "猴",
      雞: "雞",
      狗: "狗",
      豬: "豬",
    },

    westernZodiac: {
      aries: "牡羊座",
      taurus: "金牛座",
      gemini: "雙子座",
      cancer: "巨蟹座",
      leo: "獅子座",
      virgo: "處女座",
      libra: "天秤座",
      scorpio: "天蠍座",
      sagittarius: "射手座",
      capricorn: "摩羯座",
      aquarius: "水瓶座",
      pisces: "雙魚座",
    },
  },
};

export default zwds;
